/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SecondFactorSignInRequestDto } from '../../models/second-factor-sign-in-request-dto';
import { SignInResponseDto } from '../../models/sign-in-response-dto';

export interface TwoFactorSignIn$Params {
  'X-API-Version'?: string;
      body: SecondFactorSignInRequestDto
}

export function twoFactorSignIn(http: HttpClient, rootUrl: string, params: TwoFactorSignIn$Params, context?: HttpContext): Observable<StrictHttpResponse<SignInResponseDto>> {
  const rb = new RequestBuilder(rootUrl, twoFactorSignIn.PATH, 'put');
  if (params) {
    rb.header('X-API-Version', params['X-API-Version'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SignInResponseDto>;
    })
  );
}

twoFactorSignIn.PATH = '/api/session/mfa-token';
